import innerQueryRadioReducer from './queryRadioReducer';
const initialState = {
    query: {
        query: [],
        response: {
            format: 'json-stat'
        }
    }
}
export default ( state = initialState, action) => {
    switch(action.type){
        case 'SET_QUERY_VALUES_RADIO':
            return {...state, query: action.payload};
        case 'SET_STATUS_CHECK_RADIO':
            const query = {...state.query, query: innerQueryRadioReducer(state.query.query, action)}
            return {...state, query}
        default:
            return state;
    }
}


